import styled from 'styled-components';
import { BaseIcon } from './base/BaseIcon';
import d from './paths/chevron-up';

export const ChevronUpIcon = styled(BaseIcon).attrs({ d })``;
